import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { ApiDataResponse, BaseApiDataResponse } from '../Models/ApiData';
import {
    Vehicule,
    VehiculeDetailsApiDataResponse,
    VehiculeListOrder,
    VehiculeListResponse,
} from '../Models/Vehicules/Vehicule';
import { BaseDataService } from './Base/BaseDataService';

export const VehiculeEndpoints = {
    VEHICULES: '/api/v1/back/vehicules',
    VEHICULE: (vehiculeId: string) => `/api/v1/back/vehicules/${vehiculeId}`,
    UPDATE_VEHICULE: (vehiculeId: string) => `/api/v1/back/vehicules/${vehiculeId}`,
    CREATE_VEHICULE: '/api/v1/back/vehicules',
    EXPORT_VEHICULE_LIST: '/api/v1/back/vehicules/export',
};

export interface IVehiculeDataService {
    listVehicule: (
        params: {
            search?: string;
            order?: VehiculeListOrder;
            is_actif?: boolean;
        },
        cts: XHRRequestCanceler
    ) => Promise<VehiculeListResponse>;

    getVehicule: (
        cts: XHRRequestCanceler,
        vehiculeId: string
    ) => Promise<VehiculeDetailsApiDataResponse>;

    updateVehicule: (
        vehiculeId: string,
        vehicule: Vehicule,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    createVehicule: (
        vehicule: Vehicule,
        cts: XHRRequestCanceler
    ) => Promise<ApiDataResponse<string>>;
}

class VehiculeDataService extends BaseDataService implements IVehiculeDataService {
    listVehicule = async (
        params: {
            search?: string;
            order?: VehiculeListOrder;
            is_actif?: boolean;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<VehiculeListResponse>(VehiculeEndpoints.VEHICULES, cts, {
            params,
        });
    };

    getVehicule = async (cts: XHRRequestCanceler, vehiculeId: string) => {
        return this.get<VehiculeDetailsApiDataResponse>(
            VehiculeEndpoints.VEHICULE(vehiculeId),
            cts
        );
    };

    updateVehicule = async (vehiculeId: string, vehicule: Vehicule, cts: XHRRequestCanceler) => {
        const body = {
            compagnon_id: vehicule.compagnon?.compagnon_id,
            ...vehicule,
        };
        return this.patch(VehiculeEndpoints.UPDATE_VEHICULE(vehiculeId), body, cts);
    };

    createVehicule = async (vehicule: Vehicule, cts: XHRRequestCanceler) => {
        const body = {
            compagnon_id: vehicule.compagnon?.compagnon_id,
            ...vehicule,
        };
        return this.post<ApiDataResponse<string>>(VehiculeEndpoints.CREATE_VEHICULE, body, cts);
    };
}

const VehiculeDataServiceName = 'VehiculeDataService';
export { VehiculeDataService, VehiculeDataServiceName };
